import $ from 'jquery';
import _ from 'underscore';


const elementsMap = {

	//Rules tab
  rulesSatisfiesAnyAlert : ".rules-satisfies-any-alert",
  noRulesAlert : ".no-rules-alert",
  rulesTabRulesAlert : ".rules-tab-rules-alert"

};

export default function CollateralRulesTab(wizard) {
  const self = this;
  const els = {};
  const wizardElement = wizard.getWizardElement();
  const namespace = wizardElement.data("namespace").trim();
  const collateralRules = wizardElement.data("collateral-rules");
  const collateralRuleConditionsUrl = wizardElement.data("get-collateral-rule-conditions"); 
  const collateralDetailItmRules = wizardElement.data("collateral-detail-itm-rule-mapping"); 
  var collateralRulesTable;

  self.init = function(){
   	setElements();
	checkRulesInUse();
  };

  self.didNavigateToForm = function(){
    checkForRules();
  };

  function setElements(){
    setElementsFromScope(els, elementsMap, wizardElement);
  }

  function setElementsFromScope(targetObj, elementsDict, scope){
    _(elementsDict).each((v, k)=>{
      targetObj[k] = scope.find(v);
    });
  }

  function checkForRules(){

    if(collateralRules == null || collateralRules.length == 0)
    {
      els.rulesSatisfiesAnyAlert.hide();
      els.rulesTabRulesAlert.hide();
      els.noRulesAlert.show();  
    }
    else
    {
      els.rulesSatisfiesAnyAlert.show();
      els.rulesTabRulesAlert.show();
      els.noRulesAlert.hide();  
    }
    
  }

  function checkRulesInUse()
  {
    if(collateralDetailItmRules!=null && collateralDetailItmRules.length>0)
    {
     $.each(collateralDetailItmRules, function(key, value){
      $("#cbrId-"+value.clrCbrId).prop('checked', true);
	  $("#qtyPerRule-"+value.clrCbrId).val(value.clrQtyPerRule);
	  $("#qtyPerRule-"+value.clrCbrId).prop('disabled', false);
      });
    }
  }

 collateralRulesTable = $('#collateral-rules-table-id').dataTable({
    select: {
      style:    'os',
      selector: 'td:first-child'
    },
    data: collateralRules,
    "bPaginate": false,
    "searchable": false,
    "order": [[ 1, "asc" ]],
    columns: [
      { data:   "cbrId", "orderable": false,
        render: function ( data, type, row ) {
           if ( type === 'display' ) {
            let html = '<div class="checkbox checkbox-success cb-large collateralRulesCheckbox">' +
              '<input type="checkbox" id="cbrId-' + row.cbrId + '" value="' + row.cbrId + '" name="collateralRules" class="collateralRulesLookup"/>' +
              '<label for="cbrId-' + row.cbrId + '"></label>' +
            '</div>';
            return html;
          }
          return data;
        },
        className: "select-checkbox", width: "45px"},
      { data: "cbrName", "class":"details-control rule-name first-element-containing-data"},
      { data: "cbrActive", "class":"details-control second-element-containing-data", 
		render: function ( data, type, row ) {
			if(row.cbrActive){
				let html = 	'<div class="rule-status">' +
							'<div class="q-pill q-pill-blue q-pad-vert-xxs q-pill-stretch">Active</div>' +
						'</div>';
				return html;		
			}else{
				let html = 	'<div class="rule-status">' +
							'<div class="q-pill q-pill-light-grey q-pad-vert-xxs q-pill-stretch">Inactive</div>' +
						'</div>';
				return html;				
			}
		}
	  },
	  { data: "cbrId", "orderable": false, "class":"details-control rule-number",
        render: function ( data, type, row ) {
           if ( type === 'display' ) {
            let html = '<div>' +
              '<input type="number" id="qtyPerRule-' + row.cbrId + '" name="qtyPerRule-' + row.cbrId + '" disabled min="1" step="1" class="q-input stretch required third-element-containing-data"/>' +
			  '<label for="clrId-' + row.cbrId + '"></label>' +
            '</div>';
            return html;
          }
          return data;
        }
	  },
      { data: "cbrId", "orderable": false,
        render: function ( data, type, row ) {
           if ( type === 'display' ) {
            let html = '<div class="rule-details forth-element-containing-data">' +
              '<a href="#" class="rule-details-link" id="' + row.cbrId + '" name="cbrIdDetailsLink" value="' + row.cbrId + '">' +
              '<i class="fa fa-eye" aria-hidden="true"></i> View Rule Details' +
            '</a></div>';
            return html;
          }
          return data;
        }
      }
    ]

  });
  
  $('input[name="collateralRules"]').change(function(e){
	if($(this).prop('checked')){
		$('#qtyPerRule-'+$(this).val()).prop('disabled', false);
	}else{
		$('#qtyPerRule-'+$(this).val()).prop('disabled', true);
	}
  });

function getBusinessRuleConitions({data, success, error}){
    
    $.ajax({
      data: {
              [`${namespace}cbrId`]: data
            },
      url: collateralRuleConditionsUrl,
      dataType:"JSON",
      type: 'POST',
      success: success,
      error: error
    });
  }
  
  $(document).on("click", ".rule-details-link", function(e){
	e.preventDefault();
    let businessRuleId = this.id;
    getBusinessRuleConitions({data: businessRuleId, success: findCollateralRuleConditionSucess, error: findCollateralRuleConditionError});
    
    });


    function findCollateralRuleConditionSucess(response)
    {
      //const rule = JSON.stringify(response);
      $("#rule-effective-dates").html("Effective from "+ timestampToDate(response.cbrEffectiveStartDate) + " until " + timestampToDate(response.cbrEffectiveEndDate) );
      $("#rule-conditions-and-params").html(response.displayCmrRuleConditions);
      $("#collateral-rulesTab-modal").appendTo("body").modal("show");
    }

    function findCollateralRuleConditionError()
    {
      console.log("Error");
    }

    function timestampToDate(createdDate)
    {
      let date = new Date(createdDate); //createdDate is long time format
      let month = date.getMonth() + 1;
      return (month > 9 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear();
    }
    
}


// WEBPACK FOOTER //
// ./src/pages/products/CollateralRulesTab.js